// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + (chunkId === 50 ? "npm.docx" : chunkId) + "." + {"50":"57c516f9","249":"0e9da3ec"}[chunkId] + ".js";
};